import { hashValue } from '@ggs/utils'

/**
 * Settings action types.
 * @enum {string}
 */
export const settingsActionType = {
  CLEAR_NOTICE: 'CLEAR_NOTICE',
  SET_CURRENT_LANGUAGE: 'SET_CURRENT_LANGUAGE',
  SET_CAMPUS: 'SET_CAMPUS',
  SET_ACADEMIC_PERIOD: 'SET_ACADEMIC_PERIOD',
}

/**
 * @typedef {Object} SetCurrentLanguageActionPayload
 * @property {String} language
 */

/**
 * @typedef {Object} SetCurrentLanguageAction
 * @property {settingsActionType} type Action type key
 * @property {SetCurrentLanguageActionPayload} payload Action input data
 */

/**
 * Set current market action.
 *
 * @param {String} language CL market ID
 * @return {SetCurrentLanguageAction}
 */
export const setCurrentLanguage = (language) => {
  return {
    type: settingsActionType.SET_CURRENT_LANGUAGE,
    payload: {
      language,
    },
  }
}

/**
 * @typedef {Object} ClearNoticeAction
 * @property {settingsActionType} type Action type key
 * @property {String} payload
 */

/**
 * Action to clear specific UI alert by ID.
 * @param {String} label The alert ID to clear
 * @return {ClearNoticeAction} Action object.
 */
export const clearNotice = (label) => {
  return {
    type: settingsActionType.CLEAR_NOTICE,
    payload: hashValue(label),
  }
}

/**
 * @typedef {Object} SetSettingActionPayload
 * @property {String} value
 */

/**
 * @typedef {Object} SetSettingAction
 * @property {settingsActionType} type Action type key
 * @property {SetSettingActionPayload} payload Action input data
 */

/**
 * Set campus setting.
 *
 * @param {String} campus Campus ID
 * @return {SetSettingAction}
 */
export const setCampus = (campus) => {
  return {
    type: settingsActionType.SET_CAMPUS,
    payload: {
      value: campus,
    },
  }
}

/**
 * Set academic period setting.
 *
 * @param {String} academicPeriod Academic period ID
 * @return {SetSettingAction}
 */
export const setAcademicPeriod = (academicPeriod) => {
  return {
    type: settingsActionType.SET_ACADEMIC_PERIOD,
    payload: {
      value: academicPeriod,
    },
  }
}
